import React from 'react';
import { OverwhelmWavesIcon } from './overwhelm-waves-icon';
import { TopicCardDivider, TopicCardTitle, TOPIC_CARD_ICON_1 } from './topic-card-shared';

import overwhelmPersonImage from './overwhelm-person.webp';

interface OverwhelmTopicCardProps {
  title: string;
  className?: string;
}

export const OverwhelmTopicCard: React.FC<OverwhelmTopicCardProps> = ({ title, className = '' }) => (
  <div
    className={`flex w-full min-w-0 flex-col items-center justify-center overflow-hidden rounded-xl bg-white px-2 pb-4 pt-3 sm:px-4 sm:pb-8 sm:pt-6 ${className}`}
  >
    <div className="mt-1 flex w-full flex-col items-center sm:mt-2">
      <div className="relative flex items-start justify-center">
        <div className="absolute left-0 top-4 h-[48px] w-[66px] shrink-0 sm:top-6 sm:h-[72.394px] sm:w-[99.359px]">
          <OverwhelmWavesIcon fill={TOPIC_CARD_ICON_1} className="h-full w-full" />
        </div>
        <img
          src={overwhelmPersonImage}
          alt=""
          className="relative z-10 ml-10 aspect-[69/88] w-[77px] shrink-0 object-cover object-top sm:ml-16 sm:w-[116.045px]"
        />
      </div>
      <TopicCardDivider />
    </div>
    <TopicCardTitle title={title} />
  </div>
);
